export enum PathNames {
  // Auth
  login = "/",
  passwordRecovery = "/password-recovery",
  passwordRecoveryReset = "/password-recovery-reset",
  changePassword = "/change-password",
  registration = "/registration",
  registrationBilling = "/registration-billing",
  registrationSubscriptionPlan = "/registration-subscription-plan",
  registrationPayment = "/registration-payment",
  registrationTerms = "/registration-terms",
  // App
  home = "/",
  error = "/error",
}
